export default __webpack_public_path__ + "static/babcoc-logo-web-scaled-da8e54456717f7d2c703cb440cd0b34a.jpg";